<script setup lang="ts">
import PageTitle from '../controls/PageTitle.vue';

</script>

<template>
  <div class="form-container">

    <PageTitle text="Logout"></PageTitle>

    <div class="row">
      <div class="col-xs-12">
        <div class="box-row card cardshadow">            
            <p>Du hast dich erfolgreich ausgeloggt.</p>
        </div>
      </div>
    </div>


  </div>
</template>

<style scoped>
.card {
  background-color: white;
    padding: 2rem
}

.divider {
  border-bottom: 1px solid lightgray;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

</style>
